var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasurementQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 14C21.7301 14 20.6001 14.8 20.1801 16H14.0001V18H15.9501L13.0001 25C12.5301 27 14.0001 28 16.5001 28C19.0001 28 20.5601 27 20.0001 25L17.0501 18H20.1701C20.5001 18.85 21.1501 19.5 22.0001 19.83V31H13.0001V33H33.0001V31H24.0001V19.82C24.8501 19.5 25.5001 18.85 25.8201 18H28.9501L26.0001 25C25.5301 27 27.0001 28 29.5001 28C32.0001 28 33.5601 27 33.0001 25L30.0501 18H32.0001V16H25.8301C25.4001 14.8 24.2701 14 23.0001 14ZM23.0001 16C23.2653 16 23.5196 16.1054 23.7072 16.2929C23.8947 16.4804 24.0001 16.7348 24.0001 17C24.0001 17.2652 23.8947 17.5196 23.7072 17.7071C23.5196 17.8946 23.2653 18 23.0001 18C22.7348 18 22.4805 17.8946 22.2929 17.7071C22.1054 17.5196 22.0001 17.2652 22.0001 17C22.0001 16.7348 22.1054 16.4804 22.2929 16.2929C22.4805 16.1054 22.7348 16 23.0001 16ZM16.5001 21.25L18.0001 25H15.0001L16.5001 21.25ZM29.5001 21.25L31.0001 25H28.0001L29.5001 21.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementQuestion);
export default __webpack_public_path__ + "static/media/MeasurementQuestion.d4b1b63629f3c7ac9e0804b79e3d1881.svg";
export { ForwardRef as ReactComponent };